module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_vii",
      "title": "vii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTNIS"
  }, [_vm._v("The following people have my undying gratitude, and deserve special mention here; without them, you would not be holding this book in your hands:")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("Irwin Rumler")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("Russell Galen")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("Charles Spicer")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("April Osborn")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("David Blixt")]), _vm._v(" "), _c('p', {
    staticClass: "FMSTX"
  }, [_vm._v("I’d like to thank each of the following individuals for supporting me in finishing this novel:")]), _vm._v(" "), _c('p', {
    staticClass: "CL2F"
  }, [_vm._v("George A. Kalogridis")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Jan Davis and Mitchell Kalogridis")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Keith Macksey")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Melissa Clepper-Faith")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Jerry Miller")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Kathy, Matt, Daemon, and Lily Prorok")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("C. W. Gortner")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Jackie Sewell")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Tim Waggoner")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Dimitri LaBarge")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Teresa Bigbee")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_viii",
      "title": "viii"
    }
  }, [_vm._v("Kent Burden")])]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Frank Carbone")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("David Tocher")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Samina Patel Sharp")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Bob Dev")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("J. Martin")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Kristina Butke")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Mike Cobley")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("H. W. Shannon")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("sidhekist")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("kayaking.gram")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("jcpete")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("hardboiledbaby")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("dolleygurl")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Trent Zelazny")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Dawn Rice")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Laura Lewis")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Matt Phillips")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("M. J. Rose")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Vidura Barrios")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Warren Lapine")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Andy Michael")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Nat P.")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Sarah Waterhouse")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Karen Essex")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Leslie Carrol")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Jonah Kit")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Laura Watkins")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Bob Moats")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Winston")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Gio Pompele")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Vincent Docherty")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("Richard Dansky")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("edidep")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("dlteana.graham9")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("lesliegski")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("usmantm")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("cesc.rosello")]), _vm._v(" "), _c('p', {
    staticClass: "CL2"
  }, [_vm._v("hfvrtualbooktours")]), _vm._v(" "), _c('p', {
    staticClass: "FMSTX"
  }, [_vm._v("My special thanks, also, to those who contributed anonymously; you know who you are.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c150588c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0